/*
 * Custom Link component to handle false active classes involving modal routes
*/

import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Link({ className, activeClassName, children, to, ...rest }) {
  const location = useLocation()
  const isActive = () => {
    if (typeof to !== "string") return false

    if (location.pathname === '/' && to === '/') return true

    if (to === '/') return false

    if (location.pathname.includes(to)) return true
  }

  return (
    <NavLink {...rest} className={classNames(className, isActive() ? activeClassName : undefined)} to={to}>{children}</NavLink>
  )
}
